const initialState = {
    token: null,
    userInfo: null
}
export function dataReducer(state = initialState, action) {
    const { type, data } = action
    switch (type) {
        case "set_token":
            return {...state,token:data}
        case "set_userInfo":
            return {...state,userInfo:data}
        default:
            return state
    }
}